/** @jsx jsx */
import { jsx } from 'theme-ui';
export var SummaryTable = function (_a) {
    var className = _a.className, children = _a.children;
    return (jsx("div", { className: className, sx: {
            borderRadius: function (t) { return t.borderRadius; },
            borderColor: 'grey',
            borderWidth: 1,
            borderStyle: 'solid',
        } }, children));
};
export var SummaryRow = function (_a) {
    var className = _a.className, label = _a.label, children = _a.children;
    return (jsx("div", { className: className, sx: {
            borderWidth: 1,
            borderColor: 'grey',
            borderBottomStyle: 'solid',
            '&:last-of-type': { border: 'none' },
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
        } },
        jsx("div", { sx: {
                bg: '#f5f5f5',
                borderWidth: 1,
                borderColor: 'grey',
                borderRightStyle: 'solid',
                p: 2,
                flex: 1,
                minWidth: [100, 100, 220],
                fontWeight: 'bold',
            } }, label),
        jsx("div", { sx: { p: 2, flex: 7 } }, children)));
};
export var NoneSet = function (_a) {
    var className = _a.className, children = _a.children;
    return (jsx("div", { className: className, sx: { color: 'muted', fontStyle: 'italic' } }, children || 'None set'));
};
//# sourceMappingURL=SummaryTable.js.map